import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { IoMdClose } from 'react-icons/io';
import useScreenSize from '../../hooks/useScreenSize';

interface CustomModalProps {
  modalTitle: string;
  isOpen: boolean;
  fullscreenOnMobile?: boolean;
  setIsOpenModal: (isOpen: boolean) => void;
  onCloseModal?: () => void;
  isLoading?: boolean;
  children: React.ReactNode;
}

export default function CustomModal({
  modalTitle,
  isOpen,
  setIsOpenModal,
  onCloseModal,
  children,
  isLoading = false,
  fullscreenOnMobile = true,
}: CustomModalProps) {
  const [screenWidth, screenHeight] = useScreenSize();
  const [styles, setStyles] = useState({});

  const getCustomStyles = () => {
    return {
      content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        minWidth: '50%',
        maxWidth: '85%',
        maxHeight: '90%',
        transform: 'translate(-50%, -50%)',
        overflow: 'hidden',
        width: 'auto',
      },
    };
  };

  useEffect(() => {
    if (screenWidth && screenHeight) {
      let customStyles = getCustomStyles();
      if (screenWidth < 576 || screenHeight < 576) {
        if (!fullscreenOnMobile) {
          customStyles.content.width = '90%';
          customStyles.content.maxWidth = '90%';
        } else {
          customStyles.content.top = '0';
          customStyles.content.left = '0';
          customStyles.content.bottom = '0';
          customStyles.content.right = '0';
          customStyles.content.maxWidth = '100%';
          customStyles.content.maxHeight = '100%';
          customStyles.content.transform = 'none';
        }
      } else {
        customStyles = getCustomStyles();
      }

      setStyles(customStyles);
    }
  }, [screenWidth, screenHeight]);

  return (
    <div>
      <Modal
        isOpen={isOpen}
        onAfterClose={onCloseModal}
        // onRequestClose={closeModal}
        style={styles}
      >
        <div className='d-flex justify-content-between gap-2'>
          <h5>{modalTitle}</h5>
          <button
            type='button'
            className='btn p-0 align-self-start'
            onClick={() => setIsOpenModal(false)}
          >
            <IoMdClose size={20} />
          </button>
        </div>
        <hr />
        {isLoading ? (
          <div className='text-center'>
            <strong role='status'>Carregando...</strong>
            <div className='d-flex justify-content-center'>
              <div className='spinner-border mt-5' role='status'>
                <span className='visually-hidden'>Carregando...</span>
              </div>
            </div>
          </div>
        ) : (
          <div className='overflow-auto' style={{ maxHeight: '75vh' }}>
            {children}
          </div>
        )}
      </Modal>
    </div>
  );
}
